"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraInfoHeaderSection = void 0;
const React = require("react");
const react_1 = require("react");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const RetailCustomerProfileModal_1 = require("../../../modals/RetailCustomerProfileModal");
const DietaryInformationModal_1 = require("../../../modals/DietaryInformationModal");
const CircularIcon_1 = require("../../../../../../components/base/atoms/CircularIcon");
const useClient_1 = require("../../../../../../hooks/useClient");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ExtraInfoHeaderSection");
const ExtraInfoHeaderSection = ({}) => {
    const client = (0, useClient_1.useClient)();
    const { auth: { session } } = client;
    const retailCustomer = (0, react_1.useMemo)(() => session && session.retailCustomer, [
        session
    ]);
    const [dietaryInfoOpen, setDietaryInfoOpen] = (0, react_1.useState)(false);
    const [profileOpen, setProfileOpen] = (0, react_1.useState)(false);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("greeting") }, retailCustomer && `Welcome back, ${retailCustomer.firstName}!`),
        React.createElement("div", { className: css("icons") },
            React.createElement(CircularIcon_1.CircularIcon, { name: "info-circle", className: css("icons_icon"), onClick: () => {
                    setDietaryInfoOpen(true);
                }, size: standardSizes_1.TStandardSizes.Small }),
            React.createElement(CircularIcon_1.CircularIcon, { name: "user", className: css("icons_icon"), onClick: () => {
                    setProfileOpen(true);
                }, size: standardSizes_1.TStandardSizes.Small })),
        React.createElement(DietaryInformationModal_1.DietaryInformationModal, { open: dietaryInfoOpen, setOpen: setDietaryInfoOpen }),
        React.createElement(RetailCustomerProfileModal_1.RetailCustomerProfileModal, { profileOpen: profileOpen, setProfileOpen: setProfileOpen })));
};
exports.ExtraInfoHeaderSection = ExtraInfoHeaderSection;
//# sourceMappingURL=index.js.map